import React from 'react'

import { MarineWriteIn } from 'containers/MarineWriteIn'
import AssetType from 'state/enums/AssetType'

import { FieldConfigBase, FieldProps } from '../../containers/FormBuilder'

export interface MarineWriteInBaseFieldConfig extends FieldConfigBase {
    assetType: AssetType
    prefilled?: boolean
}

export default function MarineWriteInBaseField(
    props: FieldProps<MarineWriteInBaseFieldConfig>,
) {
    const { fieldKit, fieldConfig } = props

    return <MarineWriteIn formik={fieldKit} prefilled={fieldConfig.prefilled} />
}
